<template>
  <section>
    <b-button
      v-if="isModal"
      size="is-small"
      class="login-trigger-button"
      style="border-radius: 6px"
      outlined
      @click="handleShowLogin()"
      >登录</b-button
    >
    <b-modal
      v-if="isModal"
      v-model="isComponentModalActive"
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Example Modal"
      close-button-aria-label="Close"
      aria-modal
    >
      <div class="login-box">
        <div class="login-box-l"></div>
        <div class="login-box-r">
          <div class="login-tabs">
            <div
              class="tab-item"
              :class="{ active: loginType === 'account' }"
              @click="switchLoginType('account')"
            >
              账号密码登录
            </div>
            <div
              class="tab-item"
              :class="{ active: loginType === 'phone' }"
              @click="switchLoginType('phone')"
            >
              验证码登录
            </div>
          </div>
          <form
            style="width: 354px"
            method="POST"
            @submit.prevent="handleLogin"
          >
            <!-- 账号密码登录 -->
            <div v-if="loginType === 'account'">
              <b-field
                style="height: 90px"
                label="用户名/手机号/邮箱"
                :message="usernameMessage"
              >
                <b-input
                  v-model="loginForm.username"
                  type="username"
                  required
                  placeholder="请输入用户名/手机号/邮箱"
                  @blur="validateUsername"
                />
              </b-field>
              <b-field style="height: 90px" label="密码" :message="pwdMessage">
                <b-input
                  v-model="loginForm.password"
                  type="password"
                  password-reveal
                  required
                  placeholder="请输入密码"
                  @blur="validatePwd"
                />
              </b-field>
              <div>
                <b-field
                  style="height: 90px"
                  label="图形验证码"
                  :message="codeMessage"
                >
                  <b-input
                    :value="loginForm.code"
                    type="text"
                    required
                    maxlength="4"
                    :has-counter="false"
                    placeholder="请输入图形验证码"
                    @input="handleAccountCaptchaInput"
                    @blur="validateCode"
                  />
                  <div
                    class="login-code"
                    style="
                      cursor: pointer;
                      margin-left: 5px;
                      height: 40px;
                      float: right;
                      background-color: #f0f1f5;
                    "
                  >
                    <img
                      style="
                        width: 100%;
                        height: 40px;
                        border: 1px solid rgba(0, 0, 0, 0.1);
                        border-radius: 2px;
                      "
                      :src="codeUrl"
                      alt="yzm"
                      @click="getCode"
                    />
                  </div>
                </b-field>
              </div>
            </div>
            <!-- 验证码登录 -->
            <div v-else>
              <b-field
                style="height: 90px"
                label="手机号/邮箱"
                :message="phoneMessage"
              >
                <b-input
                  v-model="phoneForm.account"
                  type="text"
                  required
                  placeholder="请输入手机号或邮箱"
                  @input="handlePhoneInput"
                  @blur="validatePhone"
                />
              </b-field>
              <b-field
                style="height: 90px"
                label="图形验证码"
                :message="phoneCodeMessage"
              >
                <div class="input-field">
                  <b-input
                    :value="phoneForm.code"
                    type="text"
                    required
                    maxlength="4"
                    :has-counter="false"
                    placeholder="请输入图形验证码"
                    @input="handlePhoneCaptchaInput"
                    @blur="validatePhoneCode"
                  />
                  <div
                    class="login-code"
                    style="
                      cursor: pointer;
                      margin-left: 5px;
                      height: 40px;
                      float: right;
                      background-color: #f0f1f5;
                    "
                  >
                    <img
                      style="
                        width: 100%;
                        height: 40px;
                        border: 1px solid rgba(0, 0, 0, 0.1);
                        border-radius: 2px;
                      "
                      :src="codeUrl"
                      alt="yzm"
                      @click="getCode"
                    />
                  </div>
                </div>
              </b-field>
              <b-field
                v-if="accountType"
                style="height: 90px"
                :label="verifyCodeLabel"
                :message="smsCodeMessage"
              >
                <div class="input-field">
                  <b-input
                    v-model="phoneForm.verifyCode"
                    type="text"
                    required
                    :placeholder="verifyCodePlaceholder"
                    @blur="validateSmsCode"
                  />
                  <span
                    class="send-code-btn"
                    :class="{ disabled: countdown > 0 }"
                    @click="sendVerifyCode"
                  >
                    {{ sendCodeButtonText }}
                  </span>
                </div>
              </b-field>
            </div>
            <div class="login-footer-btn">
              <b-button
                class="item-btn"
                label="取消"
                type="is-light"
                @click="isComponentModalActive = false"
              />
              <b-button
                class="item-btn"
                label="登录"
                type="is-primary"
                @click="handleLogin"
              />
            </div>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <a
                class="login-zc"
                :href="signupUrl"
                target="_blank"
                rel="noopener noreferrer"
                has-text-black
                >点击注册>></a
              >
              <a
                v-if="loginType === 'account'"
                class="login-zc"
                :href="forgetUrl"
                target="_blank"
                rel="noopener noreferrer"
                has-text-black
                >忘记密码?</a
              >
            </div>
          </form>
        </div>
      </div>
    </b-modal>
    <div class="login-box" v-else>
      <div class="login-box-l"></div>
      <div class="login-box-r">
        <div class="login-tabs">
          <div
            class="tab-item"
            :class="{ active: loginType === 'account' }"
            @click="switchLoginType('account')"
          >
            账号密码登录
          </div>
          <div
            class="tab-item"
            :class="{ active: loginType === 'phone' }"
            @click="switchLoginType('phone')"
          >
            手机号/邮箱登录
          </div>
        </div>
        <form style="width: 354px" method="POST" @submit.prevent="handleLogin">
          <!-- 账号密码登录 -->
          <div v-if="loginType === 'account'">
            <b-field
              style="height: 90px"
              label="用户名/手机号/邮箱"
              :message="usernameMessage"
            >
              <b-input
                v-model="loginForm.username"
                type="username"
                required
                placeholder="请输入用户名/手机号/邮箱"
                @blur="validateUsername"
              />
            </b-field>
            <b-field style="height: 90px" label="密码" :message="pwdMessage">
              <b-input
                v-model="loginForm.password"
                type="password"
                password-reveal
                required
                placeholder="请输入密码"
                @blur="validatePwd"
              />
            </b-field>
            <div>
              <b-field
                style="height: 90px"
                label="图形验证码"
                :message="codeMessage"
              >
                <b-input
                  :value="loginForm.code"
                  type="text"
                  required
                  maxlength="4"
                  :has-counter="false"
                  placeholder="请输入图形验证码"
                  @input="handleAccountCaptchaInput"
                  @blur="validateCode"
                />
                <div
                  class="login-code"
                  style="
                    cursor: pointer;
                    margin-left: 5px;
                    height: 40px;
                    float: right;
                    background-color: #f0f1f5;
                  "
                >
                  <img
                    style="
                      width: 100%;
                      height: 40px;
                      border: 1px solid rgba(0, 0, 0, 0.1);
                      border-radius: 2px;
                    "
                    :src="codeUrl"
                    alt="yzm"
                    @click="getCode"
                  />
                </div>
              </b-field>
            </div>
          </div>
          <!-- 验证码登录 -->
          <div v-else>
            <b-field
              style="height: 90px"
              label="手机号/邮箱"
              :message="phoneMessage"
            >
              <b-input
                v-model="phoneForm.account"
                type="text"
                required
                placeholder="请输入手机号或邮箱"
                @input="handlePhoneInput"
                @blur="validatePhone"
              />
            </b-field>
            <b-field
              v-if="accountType"
              style="height: 90px"
              label="图形验证码"
              :message="phoneCodeMessage"
            >
              <div class="input-field">
                <b-input
                  :value="phoneForm.code"
                  type="text"
                  required
                  maxlength="4"
                  :has-counter="false"
                  placeholder="请输入图形验证码"
                  @input="handlePhoneCaptchaInput"
                  @blur="validatePhoneCode"
                />
                <div
                  class="login-code"
                  style="
                    cursor: pointer;
                    margin-left: 5px;
                    height: 40px;
                    float: right;
                    background-color: #f0f1f5;
                  "
                >
                  <img
                    style="
                      width: 100%;
                      height: 40px;
                      border: 1px solid rgba(0, 0, 0, 0.1);
                      border-radius: 2px;
                    "
                    :src="codeUrl"
                    alt="yzm"
                    @click="getCode"
                  />
                </div>
              </div>
            </b-field>
            <b-field
              v-if="accountType"
              style="height: 90px"
              :label="verifyCodeLabel"
              :message="smsCodeMessage"
            >
              <div class="input-field">
                <b-input
                  v-model="phoneForm.verifyCode"
                  type="text"
                  required
                  :placeholder="verifyCodePlaceholder"
                  @blur="validateSmsCode"
                />
                <span
                  class="send-code-btn"
                  :class="{ disabled: countdown > 0 }"
                  @click="sendVerifyCode"
                >
                  {{ sendCodeButtonText }}
                </span>
              </div>
            </b-field>
          </div>
          <div class="login-footer-btn">
            <b-button
              class="item-btn"
              label="取消"
              type="is-light"
              @click="isComponentModalActive = false"
            />
            <b-button
              class="item-btn"
              label="登录"
              type="is-primary"
              @click="handleLogin"
            />
          </div>

          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <a
              class="login-zc"
              :href="signupUrl"
              target="_blank"
              rel="noopener noreferrer"
              has-text-black
              >点击注册>></a
            >
            <a
              v-if="loginType === 'account'"
              class="login-zc"
              :href="forgetUrl"
              target="_blank"
              rel="noopener noreferrer"
              has-text-black
              >忘记密码?</a
            >
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { getCodeImg, sendSmsCode, sendEmailCode } from "@/api/login";
export default {
  props: {
    isModal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      signupUrl: process.env.VUE_APP_BBS_URL + "/user/signup",
      forgetUrl: process.env.VUE_APP_BBS_URL + "/user/forget",
      indefinteToast: "",
      codeUrl: "",
      isLoading: false,
      isLoadingCaptcha: false,
      captchaRequestId: 0,
      isSendingVerifyCode: false,
      formValid: false,
      usernameMessage: "",
      usernameValid: false,
      pwdMessage: "",
      pwdValid: false,
      codeMessage: "",
      codeValid: false,
      phoneMessage: "",
      phoneValid: false,
      smsCodeMessage: "",
      smsCodeValid: false,
      phoneCodeMessage: "",
      phoneCodeValid: false,
      isComponentModalActive: false,
      loginType: "account",
      accountType: "",
      countdown: 0,
      countdownTimer: null,
      loginForm: {
        username: undefined,
        password: undefined,
        rememberMe: false,
        code: undefined,
        uuid: "",
      },
      phoneForm: {
        account: undefined,
        verifyCode: undefined,
        code: undefined,
        uuid: "",
      },
    };
  },
  computed: {
    verifyCodeLabel() {
      if (this.accountType === "email") {
        return "邮箱验证码";
      }
      if (this.accountType === "phone") {
        return "短信验证码";
      }
      return "验证码";
    },
    verifyCodePlaceholder() {
      return `请输入${this.verifyCodeLabel}`;
    },
    sendCodeButtonText() {
      return this.countdown > 0
        ? `${this.countdown}秒后重发`
        : `发送${this.verifyCodeLabel}`;
    },
    verifyCodeReceiveTarget() {
      if (this.accountType === "email") {
        return "邮箱";
      }
      if (this.accountType === "phone") {
        return "手机";
      }
      return "手机或邮箱";
    },
    loginActionName() {
      return this.accountType === "email"
        ? "emailLoginAction"
        : "phoneLoginAction";
    },
  },
  created() {
    this.loginEventHandler = () => {
      this.isComponentModalActive = true;
      this.getCode();
    };
    document.addEventListener(
      "csCustomLoginEvent",
      this.loginEventHandler,
      {
        once: false,
      }
    );
  },
  beforeDestroy() {
    this.clearCountdown();
    if (this.loginEventHandler) {
      document.removeEventListener("csCustomLoginEvent", this.loginEventHandler);
    }
  },
  methods: {
    handleShowLogin() {
      this.getCode();
      sessionStorage.setItem("attemptedURL", this.$route.fullPath);
      this.isComponentModalActive = true;
    },
    switchLoginType(type) {
      if (this.loginType === type) {
        return;
      }
      this.loginType = type;
      if (type === "phone") {
        this.handlePhoneInput();
        this.getCode();
        return;
      }
      this.resetPhoneVerifyState();
    },
    getCode() {
      if (this.isLoadingCaptcha) {
        return;
      }
      const requestId = Date.now();
      this.captchaRequestId = requestId;
      this.isLoadingCaptcha = true;
      this.loginForm.code = "";
      this.phoneForm.code = "";
      getCodeImg()
        .then((res) => {
          // 只接受最后一次验证码响应，避免响应乱序覆盖当前验证码
          if (this.captchaRequestId !== requestId || res === undefined) {
            return;
          }
          this.codeUrl = res.data;
          this.loginForm.uuid = res.id;
          this.phoneForm.uuid = res.id;
        })
        .finally(() => {
          this.isLoadingCaptcha = false;
        });
    },
    validateUsername() {
      if (!this.loginForm.username) {
        this.usernameValid = false;
        this.usernameMessage = "账号不能为空";
      } else {
        this.usernameValid = true;
        this.usernameMessage = "";
      }
    },
    validatePwd() {
      if (!this.loginForm.password) {
        this.pwdValid = false;
        this.pwdMessage = "密码不能为空";
      } else {
        this.pwdValid = true;
        this.pwdMessage = "";
      }
    },
    handleAccountCaptchaInput(value) {
      this.loginForm.code = String(value || "").replace(/\D/g, "").slice(0, 4);
    },
    handlePhoneCaptchaInput(value) {
      this.phoneForm.code = String(value || "").replace(/\D/g, "").slice(0, 4);
    },
    validateCode() {
      if (!this.loginForm.code) {
        this.codeValid = false;
        this.codeMessage = "图形验证码不能为空";
      } else {
        this.codeValid = true;
        this.codeMessage = "";
      }
    },
    detectAccountType(account) {
      const phoneRegex = /^1[3-9]\d{9}$/;
      const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      const currentAccount = (account || "").trim();
      if (phoneRegex.test(currentAccount)) {
        return "phone";
      }
      if (emailRegex.test(currentAccount)) {
        return "email";
      }
      return "";
    },
    getAccountFieldName() {
      return this.accountType === "email" ? "email" : "mobile";
    },
    getVerifyCodeFieldName() {
      return this.accountType === "email" ? "emailCode" : "smsCode";
    },
    clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.countdown = 0;
    },
    resetPhoneVerifyState() {
      this.clearCountdown();
      this.phoneForm.code = undefined;
      this.phoneForm.verifyCode = undefined;
      this.phoneCodeValid = false;
      this.phoneCodeMessage = "";
      this.smsCodeValid = false;
      this.smsCodeMessage = "";
    },
    handlePhoneInput() {
      this.accountType = this.detectAccountType(this.phoneForm.account);
      this.resetPhoneVerifyState();
    },
    getVerifyCodeEmptyMessage() {
      return `${this.verifyCodeLabel}不能为空`;
    },
    getPhoneLoginSubmitMessage() {
      if (!this.phoneForm.account) {
        return "请输入手机号或邮箱";
      }
      if (!this.accountType) {
        return "请输入正确的手机号或邮箱";
      }
      if (!this.phoneForm.code) {
        return "请输入图形验证码";
      }
      if (!this.phoneForm.verifyCode) {
        return `请输入${this.verifyCodeLabel}`;
      }
      return `请检查输入的手机号/邮箱、图形验证码和${this.verifyCodeLabel}`;
    },
    validatePhone() {
      const account = (this.phoneForm.account || "").trim();
      this.phoneForm.account = account;
      this.accountType = this.detectAccountType(account);
      if (!account) {
        this.phoneValid = false;
        this.phoneMessage = "手机号或邮箱不能为空";
      } else if (!this.accountType) {
        this.phoneValid = false;
        this.phoneMessage = "请输入正确的手机号或邮箱";
      } else {
        this.phoneValid = true;
        this.phoneMessage = "";
      }
    },
    validateSmsCode() {
      if (!this.phoneForm.verifyCode) {
        this.smsCodeValid = false;
        this.smsCodeMessage = this.getVerifyCodeEmptyMessage();
      } else {
        this.smsCodeValid = true;
        this.smsCodeMessage = "";
      }
    },
    validatePhoneCode() {
      if (!this.phoneForm.code) {
        this.phoneCodeValid = false;
        this.phoneCodeMessage = "图形验证码不能为空";
      } else {
        this.phoneCodeValid = true;
        this.phoneCodeMessage = "";
      }
    },
    buildSendCodeData() {
      return {
        [this.getAccountFieldName()]: this.phoneForm.account,
        uuid: this.phoneForm.uuid,
        code: this.phoneForm.code,
      };
    },
    buildLoginData() {
      return {
        [this.getAccountFieldName()]: this.phoneForm.account,
        [this.getVerifyCodeFieldName()]: this.phoneForm.verifyCode,
      };
    },
    sendVerifyCode() {
      if (this.countdown > 0 || this.isSendingVerifyCode) {
        return;
      }
      if (!this.phoneValid) {
        this.validatePhone();
        if (!this.phoneValid) {
          return;
        }
      }
      if (!this.phoneCodeValid) {
        this.validatePhoneCode();
        if (!this.phoneCodeValid) {
          return;
        }
      }
      const data = this.buildSendCodeData();
      const request = this.accountType === "email" ? sendEmailCode : sendSmsCode;
      this.isSendingVerifyCode = true;
      request(data)
        .then((rr) => {
          if (rr.code === 500) {
            this.phoneForm.code = "";
            this.indefinteToast = this.$buefy.toast.open({
              duration: 2000,
              message: rr.msg,
              type: "is-danger",
            });
            this.getCode();
            return;
          }
          this.clearCountdown();
          this.countdown = 60;
          this.countdownTimer = setInterval(() => {
            this.countdown--;
            if (this.countdown <= 0) {
              this.clearCountdown();
            }
          }, 1000);
          this.indefinteToast = this.$buefy.toast.open({
            duration: 2000,
            message: `${this.verifyCodeLabel}已发送，请注意查收${this.verifyCodeReceiveTarget}`,
            type: "is-success",
          });
        })
        .catch(() => {
          this.getCode();
        })
        .finally(() => {
          this.isSendingVerifyCode = false;
        });
    },
    handleLogin(e) {
      if (this.isLoading) {
        return;
      }
      if (this.loginType === "account") {
        this.validateUsername();
        this.validatePwd();
        this.validateCode();
        if (!this.pwdValid || !this.usernameValid || !this.codeValid) {
          this.indefinteToast = this.$buefy.toast.open({
            duration: 3000,
            message: `请检查输入的账号、密码和图形验证码`,
            type: "is-warning",
          });
          return;
        }
        this.isLoading = true;
        this.$store
          .dispatch("login", this.loginForm)
          .then((res) => {
            this.isComponentModalActive = false;
            console.log("login success");
            this.$emit("loginSuccess");
            const okEvent = new CustomEvent("csCustomLoginSuccessEvent", {
              detail: {}, // 自定义事件的详细信息
              bubbles: true, // 事件是否冒泡
              cancelable: true, // 事件是否可以被取消
            });
            document.dispatchEvent(okEvent);
          })
          .catch((err) => {
            this.loginForm.code = "";
            this.getCode();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.validatePhone();
        if (this.accountType) {
          this.validatePhoneCode();
          this.validateSmsCode();
        }
        if (!this.phoneValid || !this.smsCodeValid || !this.phoneCodeValid) {
          this.phoneForm.verifyCode = "";
          this.phoneForm.code = "";
          this.getCode();
          this.indefinteToast = this.$buefy.toast.open({
            duration: 3000,
            message: this.getPhoneLoginSubmitMessage(),
            type: "is-warning",
          });
          return;
        }
        this.isLoading = true;
        this.$store
          .dispatch(this.loginActionName, this.buildLoginData())
          .then((res) => {
            this.isComponentModalActive = false;
            console.log("phone login success");
            this.$emit("loginSuccess");
            const okEvent = new CustomEvent("csCustomLoginSuccessEvent", {
              detail: {},
              bubbles: true,
              cancelable: true,
            });
            document.dispatchEvent(okEvent);
          })
          .catch((err) => {
            this.phoneForm.verifyCode = "";
            this.phoneForm.code = "";
            this.getCode();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-zc {
  outline: none;
  color: #57aecc;
  font-size: 14px;
}
.login-trigger-button {
  border-color: #57aecc;
  color: #57aecc;
  width: 75px;
  height: 35px;
  line-height: 45px;
  text-align: center;
  border-radius: 10px !important;
  font-size: 18px;
  font-weight: 500;
}
.login-trigger-button:hover {
  background-color: #57aecc;
  color: #fff;
}
.login-footer-btn {
  display: flex;
  justify-content: space-between;
  padding: 20px 0 10px;
  box-sizing: border-box;
  .item-btn {
    flex: 1;
    &:first-child {
      margin-right: 20px;
    }
  }
}
.login-box-r {
  margin: 0 auto;
  text-align: left;
  padding-top: 40px;
}
.login-box {
  width: 950px;
  height: 540px;
  background-color: #fff;
  display: flex;
  align-items: center;
  z-index: 1000;
  .login-box-l {
    width: 50%;
    height: 540px;
    background: url("../assets/login/login-bg.png") no-repeat center center;
    background-size: cover;
  }
}
.login-tabs {
  display: flex;
  margin-bottom: 30px;
  border-bottom: 2px solid #e0e0e0;

  .tab-item {
    flex: 1;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    transition: all 0.3s;
    position: relative;
    text-align: center;

    &:hover {
      color: #57aecc;
    }

    &.active {
      color: #57aecc;
      font-weight: 500;

      &::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: #57aecc;
      }
    }
  }
}
.login-btn {
  cursor: pointer;
  width: 60px;
  line-height: 26px;
  border-radius: 6px;
  border: 1px solid rgba(73, 168, 200, 1);
  font-size: 14px;
  font-weight: 500;
  color: rgba(87, 174, 204, 1);
  text-align: center;
}
.input-field {
  display: flex;
  align-items: center;
  gap: 6px;
  .control {
    flex: 1;
  }
  .send-code-btn {
    color: #57aecc;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    user-select: none;

    &:hover:not(.disabled) {
      color: #4a96b3;
      text-decoration: underline;
    }

    &.disabled {
      color: #ccc;
      cursor: not-allowed;
    }
  }
}
.field :deep(.help) {
  color: hsl(348, 86%, 61%);
}
</style>
